export default "__VITE_ASSET__B8Ghnf6C__"